import { queryOptions, useQuery } from '@tanstack/react-query';

import { usersApi } from '../api/users-api';

import { userKeys } from './user-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function userListQueryOptions() {
  return queryOptions({ queryKey: userKeys.list(), queryFn: usersApi.list });
}

export function useUsers() {
  return useQuery(userListQueryOptions());
}
